module.exports = __webpack_public_path__ + "static/any_size-bf263df81509ad40645782e30cdc0ad6.jpg";